module.exports = __webpack_public_path__ + "img/2020-1.9f20ba2c.jpg";